import React from 'react'
import './index.scss'

import closeIcon from './assets/close.png'
import './_variables.css'

interface PopupBottomModalProps {
  visible: boolean
  title: string
  contentClassName?: string
  children: React.ReactNode
  onClose: () => void
}
// 该组件目前只有mona-ota使用
const PopupBottomModal = ({
  visible = false,
  title = '提示',
  contentClassName = '',
  children,
  onClose = () => {}
}: PopupBottomModalProps) => {
  return (
    <div className={`popup-bottom-modal-common ${visible ? 'show' : ''}`}>
      <div className={`modal ${visible ? 'show' : ''}`} onClick={onClose}></div>
      <div className={`content ${contentClassName} ${visible ? 'show' : ''}`}>
        <div className='title-bar'>
          <img src={closeIcon} alt='' className='icon-close' onClick={onClose} />
          <div className='title'>{title}</div>
        </div>
        {children}
      </div>
    </div>
  )
}

export default PopupBottomModal
